import {
  useController,
  type FieldValues,
  type UseControllerProps,
} from "react-hook-form";
import { Radio, type IRadioProps } from "@components/inputs/Radio/Radio";

type TFormSelectProps<T extends FieldValues> = IRadioProps &
  UseControllerProps<T>;

export const FormRadio = <T extends FieldValues>({
  name,
  control,
  ...rest
}: TFormSelectProps<T>) => {
  const controller = useController({
    name,
    control,
  });

  const {
    field,
    fieldState: { error },
  } = controller;

  const { onChange, ...fieldRest } = field;

  return (
    <Radio
      {...rest}
      {...fieldRest}
      error={error?.message}
      onRadioOptionChange={(value: string | number | boolean) =>
        onChange(value)
      }
      name={name}
      {...(rest.disabled ? { disabled: true } : {})}
    />
  );
};
